module.exports = __webpack_public_path__ + "static/media/gp_logo.b6301882.ico";